export { DMS_MODULE } from '../constants';
export const NAME = 'ZakaznikKontakt';
export const CRUMB_LABEL_KEY = 'edtZakaznikKontakt';
